// ============================================================
//  src/pages/landing/LandingPage.js
// ============================================================
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';

const reviews = [
  {
    initial: 'A',
    name: 'Amara Osei',
    role: 'Student, Enugu',
    color: '#002CED',
    quote: 'I made ₦8,000 in my first week just during breaks. The tasks are super simple and payouts genuinely instant.',
  },
  {
    initial: 'D',
    name: 'Dele Adeyemi',
    role: 'Founder, TechBridge',
    color: '#00C48C',
    quote: 'We used Cloverr to get 300 genuine reviews. The quality of engagement from real users was unmatched.',
  },
  {
    initial: 'F',
    name: 'Fatima Bello',
    role: 'Freelancer, Abuja',
    color: '#FF9500',
    quote: 'Cloverr has become my main side income. I do about 20 tasks a day — easy money on autopilot.',
  },
];

export default function LandingPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="lp">

      {/* ── Nav ── */}
      <nav className={`lp-nav${scrolled ? ' scrolled' : ''}`}>
        <Link to="/" className="lp-logo">
          <div className="lp-logo-mark">C</div>
          <span className="lp-logo-name">Cloverr</span>
        </Link>
        <div className="lp-nav-links">
          <a href="#how-it-works" className="lp-nav-link">How it works</a>
          <a href="#features" className="lp-nav-link">Features</a>
          <Link to="/login" className="lp-nav-link">Sign in</Link>
          <Link to="/register" className="lp-nav-btn">Get Started</Link>
        </div>
      </nav>

      {/* ── Hero ── */}
      <section className="lp-hero">
        <div className="lp-hero-bg" />
        <div className="lp-hero-dot-grid" />
        <div className="lp-hero-inner">
          <div className="lp-hero-text">
            <div className="lp-eyebrow">
              <div className="lp-eyebrow-dot" />
              <span>Now live in Nigeria</span>
            </div>
            <h1 className="lp-headline">
              Earn Money.<br />
              Grow Your<br />
              <em>Business.</em>
            </h1>
            <p className="lp-sub">
              Cloverr connects earners with tasks and businesses with real results.
              Complete tasks, place orders, and withdraw your earnings — all in one place.
            </p>
            <div className="lp-cta">
              <Link to="/register" className="lp-cta-primary">
                <i className="fas fa-rocket" /> Start Earning Free
              </Link>
              <Link to="/login" className="lp-cta-secondary">
                <i className="fas fa-arrow-right-to-bracket" /> Sign In
              </Link>
            </div>
            <div className="lp-trust">
              <div className="lp-trust-avatars">
                <div className="lp-trust-avatar ta1">A</div>
                <div className="lp-trust-avatar ta2">B</div>
                <div className="lp-trust-avatar ta3">C</div>
                <div className="lp-trust-avatar ta4">D</div>
              </div>
              Trusted by thousands of earners
            </div>
          </div>

          {/* ── Mock App Card ── */}
          <div className="lp-hero-card">
            {/* Floating badges — outside the card, inside the wrapper */}
            <div className="lp-float-badge lp-badge-1">
              <div className="lp-badge-icon" style={{ background: 'rgba(0,196,140,.12)', color: 'var(--success)' }}>
                <i className="fas fa-check" />
              </div>
              <span>Task completed!</span>
            </div>
            <div className="lp-float-badge lp-badge-2">
              <div className="lp-badge-icon" style={{ background: 'rgba(0,44,237,.09)', color: 'var(--primary)' }}>
                <i className="fas fa-wallet" />
              </div>
              <span>+₦2,500 credited</span>
            </div>

            <div className="lp-app-card">
              {/* Card top — wallet */}
              <div className="lp-card-top">
                <div className="lp-card-top-dot-grid" />
                <div className="lp-card-header">
                  <span className="lp-card-brand">Cloverr</span>
                  <span className="lp-card-badge">● Live</span>
                </div>
                <div className="lp-balance-lbl">Wallet Balance</div>
                <div className="lp-balance-val"><span>₦</span>48,250.00</div>
              </div>

              {/* Card body — transactions */}
              <div className="lp-card-body">
                <div className="lp-card-stat-row">
                  <div className="lp-stat-pill">
                    <div className="lp-stat-pill-lbl">Tasks Done</div>
                    <div className="lp-stat-pill-val">24</div>
                  </div>
                  <div className="lp-stat-pill">
                    <div className="lp-stat-pill-lbl">Earned</div>
                    <div className="lp-stat-pill-val">₦48k</div>
                  </div>
                </div>

                <div style={{ marginTop: 16 }}>
                  <div className="lp-card-row">
                    <div className="lp-card-row-left">
                      <div className="lp-card-icon lp-icon-green"><i className="fas fa-check-circle" /></div>
                      <div>
                        <div className="lp-card-label">Instagram Follow</div>
                        <div className="lp-card-sub">Completed</div>
                      </div>
                    </div>
                    <div className="lp-card-amt lp-amt-pos">+₦500</div>
                  </div>
                  <div className="lp-card-row">
                    <div className="lp-card-row-left">
                      <div className="lp-card-icon lp-icon-blue"><i className="fas fa-thumbs-up" /></div>
                      <div>
                        <div className="lp-card-label">YouTube Like</div>
                        <div className="lp-card-sub">Completed</div>
                      </div>
                    </div>
                    <div className="lp-card-amt lp-amt-pos">+₦250</div>
                  </div>
                  <div className="lp-card-row">
                    <div className="lp-card-row-left">
                      <div className="lp-card-icon lp-icon-orange"><i className="fas fa-arrow-up-from-bracket" /></div>
                      <div>
                        <div className="lp-card-label">Withdrawal</div>
                        <div className="lp-card-sub">Bank Transfer</div>
                      </div>
                    </div>
                    <div className="lp-card-amt lp-amt-neg">-₦10,000</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── How It Works ── */}
      <section className="lp-section" id="how-it-works">
        <div className="lp-section-inner">
          <div className="lp-section-hdr">
            <div className="lp-section-eyebrow">How it works</div>
            <h2 className="lp-section-title">Simple. Fast. Rewarding.</h2>
            <p className="lp-section-sub">Get started in minutes and start earning or growing your brand right away.</p>
          </div>
          <div className="lp-steps">
            <div className="lp-step">
              <div className="lp-step-num">1</div>
              <h3>Create your account</h3>
              <p>Sign up for free in under 60 seconds. No credit card needed — just your email and a password.</p>
            </div>
            <div className="lp-step">
              <div className="lp-step-num">2</div>
              <h3>Pick tasks or place orders</h3>
              <p>Earners browse available tasks and complete them. Businesses place orders to grow their online presence.</p>
            </div>
            <div className="lp-step">
              <div className="lp-step-num">3</div>
              <h3>Get paid instantly</h3>
              <p>Earnings land in your wallet automatically. Withdraw to your bank account anytime with no delays.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ── Features ── */}
      <section className="lp-section lp-features-bg" id="features">
        <div className="lp-section-inner">
          <div className="lp-section-hdr">
            <div className="lp-section-eyebrow">Features</div>
            <h2 className="lp-section-title">Everything you need</h2>
            <p className="lp-section-sub">Built for earners and businesses alike, with tools that make your work effortless.</p>
          </div>
          <div className="lp-features">
            {[
              { ico: 'fa-tasks',            bg: 'rgba(0,44,237,.09)',   clr: 'var(--primary)', title: 'Task Marketplace',  desc: 'Browse hundreds of micro-tasks across social media, writing, and more.' },
              { ico: 'fa-wallet',           bg: 'rgba(0,196,140,.10)', clr: 'var(--success)', title: 'Instant Wallet',    desc: 'Earnings credited instantly on task approval. No waiting period.' },
              { ico: 'fa-building-columns', bg: 'rgba(255,149,0,.10)', clr: 'var(--warning)', title: 'Bank Withdrawals',  desc: 'Withdraw to any Nigerian bank account securely and quickly.' },
              { ico: 'fa-chart-line',       bg: 'rgba(0,44,237,.09)',   clr: 'var(--primary)', title: 'Growth Orders',    desc: 'Place orders for followers, likes, views, and content services.' },
              { ico: 'fa-user-group',       bg: 'rgba(0,196,140,.10)', clr: 'var(--success)', title: 'Referral Rewards', desc: 'Invite friends and earn a bonus for every person who joins.' },
              { ico: 'fa-shield-halved',    bg: 'rgba(255,59,48,.08)',  clr: 'var(--danger)',  title: 'Secure & Trusted', desc: 'PIN protection, email verification, and encrypted transactions.' },
            ].map((f, i) => (
              <div className="lp-feat" key={i}>
                <div className="lp-feat-ico" style={{ background: f.bg, color: f.clr }}>
                  <i className={`fas ${f.ico}`} />
                </div>
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Stats ── */}
      <section className="lp-stats">
        <div className="lp-stats-dot-grid" />
        <div className="lp-stats-inner">
          <div>
            <div className="lp-stat-val">10<span>k+</span></div>
            <div className="lp-stat-lbl">Active Earners</div>
          </div>
          <div>
            <div className="lp-stat-val">₦<span>50M+</span></div>
            <div className="lp-stat-lbl">Total Paid Out</div>
          </div>
          <div>
            <div className="lp-stat-val">200<span>+</span></div>
            <div className="lp-stat-lbl">Task Types</div>
          </div>
          <div>
            <div className="lp-stat-val">99<span>%</span></div>
            <div className="lp-stat-lbl">Payout Success Rate</div>
          </div>
        </div>
      </section>

      {/* ── Reviews ── */}
      <section className="lp-section lp-reviews-section" id="reviews">
        <div className="lp-section-inner">
          <div className="lp-section-hdr">
            <div className="lp-section-eyebrow">Real stories</div>
            <h2 className="lp-section-title">People love Cloverr.</h2>
          </div>
          <div className="lp-reviews">
            {reviews.map((r, i) => (
              <div className="lp-review" key={i}>
                <div className="lp-review-stars">
                  {[...Array(5)].map((_, s) => <i key={s} className="fas fa-star" />)}
                </div>
                <p className="lp-review-quote">"{r.quote}"</p>
                <div className="lp-review-author">
                  <div className="lp-review-avatar" style={{ background: r.color }}>{r.initial}</div>
                  <div>
                    <div className="lp-review-name">{r.name}</div>
                    <div className="lp-review-role">{r.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="lp-cta-section">
        <div className="lp-cta-inner">
          <div className="lp-eyebrow" style={{ margin: '0 auto 24px' }}>
            <div className="lp-eyebrow-dot" />
            <span>Free to join</span>
          </div>
          <h2 className="lp-headline">
            Ready to start<br /><em>earning?</em>
          </h2>
          <p className="lp-sub">Join thousands of Nigerians already making money on Cloverr. Sign up free and complete your first task today.</p>
          <div className="lp-cta-btns">
            <Link to="/register" className="lp-cta-primary">
              <i className="fas fa-rocket" /> Create Free Account
            </Link>
            <Link to="/login" className="lp-cta-secondary">
              <i className="fas fa-arrow-right-to-bracket" /> Already have an account
            </Link>
          </div>
        </div>
      </section>

      {/* ── Footer ── */}
      <footer className="lp-footer">
        <div className="lp-logo">
          <div className="lp-logo-mark">C</div>
          <span className="lp-logo-name" style={{ color: 'var(--text-mid)', fontSize: 17 }}>Cloverr</span>
        </div>
        <div className="lp-footer-links">
          <a href="#how-it-works">How it works</a>
          <a href="#features">Features</a>
          <Link to="/login">Login</Link>
          <Link to="/register">Register</Link>
        </div>
        <span>© {new Date().getFullYear()} Cloverr. All rights reserved.</span>
      </footer>

    </div>
  );
}
